import { render, staticRenderFns } from "./LIKE.vue?vue&type=template&id=1a20d60c"
import script from "./LIKE.vue?vue&type=script&lang=js"
export * from "./LIKE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports